import { IRootState } from '../../../store'
import { IExposureState } from '../store/exposure.types'

export const getExposureSelector = (state: IRootState): IExposureState => state.exposure
